import { get } from "lodash";
import { RootState } from "store/rootStore";

export const selectRequests = (requests: string[], { loading }: RootState) =>
  requests.some((request) => get(loading.requests, request));
